import Grid from 'atoms/Layout/Grid/Grid';
import SenjaReviewsWithTextBlock from 'molecules/SenjaReviews/SenjaReviewsWithTextBlock';
import React from 'react';

const SenjaReviews = (): JSX.Element => (
  <Grid
    padding={['spacing-none', 'spacing-4xl']}
    paddingSm={['spacing-none', 'spacing-xl']}
  >
    <SenjaReviewsWithTextBlock
      heading={{
        type: 'heading',
        text: 'Why creators choose Mighty',
        size: 'lg',
      }}
      supportingText={{
        type: 'paragraph',
        text: 'Home to more $1M communities than any other platform.',
        size: 'xl',
        color: 'text-tertiary',
      }}
      button={{
        children: 'View all',
        size: 'xl',
        variant: 'secondary',
        href: '/reviews',
      }}
      senjaId='7ca71513-fbdb-4321-aec1-63b6493717da'
    />
  </Grid>
);

export default SenjaReviews;
